import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8ebffdb8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rel" }
const _hoisted_2 = { class: "table" }
const _hoisted_3 = { class: "head flex-ter" }
const _hoisted_4 = {
  style: {"padding":"0 20px"},
  class: "rel"
}
const _hoisted_5 = { class: "abs shop-mode" }
const _hoisted_6 = { class: "shop-mode-item" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "shop-mode-item" }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = {
  key: 0,
  class: "shop-mode-item"
}
const _hoisted_11 = { class: "title" }
const _hoisted_12 = {
  key: 1,
  class: "text-lt flex-col"
}
const _hoisted_13 = {
  class: "mr_5 mb_5",
  style: {"white-space":"nowrap"}
}
const _hoisted_14 = { class: "flex-ter mb_10" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = { class: "flex" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import UnBalanceConfirm from '@/components/UnBalanceConfirm/index.vue'
import FigurePay from './FigurePay.vue'
import { t, text } from '@/plugins/i18n'
import { ref, computed, toRef, watch, onMounted } from 'vue'
import PrevItem from './PrevItem.vue'
import { useStore } from 'vuex'
import { getCombinationServiceFreezeChargeApi } from '@/apis/shopcart'
import { purchaseCfg } from '@/apis/setup'
import { useRequest } from '@/util/useLoading'
import { ElMessageBox, ElMessage } from 'element-plus'
import { useRouter } from 'vue-router'
import { useRtfix, usePlat, isD2C, useSite, isJA, isEN, getWarehouseCode, useSite2Station, getWarehouseByCountry } from '@/store'
import bus from '@/util/useBus'
import { getWallet } from '@/apis/user'
import OpenMember from './OpenMember.vue'
import { getUser } from '@/apis/login'
import { arr2map } from '@/plugins/utils'
import { cloneDeep } from 'lodash'
import calcFee from '@/util/calcFee'
import { getTrueNumber } from '@/util/common'
import { calcGpAdt } from '@/util/calcAdt'
import confirmDialog from '@/components/common/ConfirmDialog'
import Confirmation from './Confirmation.vue'
import { OrderSuccessInfoDTO } from '../data'
import QuestionMark from '@/components/IconPark/QuestionMark.vue'
import { getPlatformOrderDetail } from '@/apis/order'
import { TaEvent, taTrack } from '@/util/buryingPoint'
import { sourceCountryInfo, sourceCountryRef, stockWarehouse } from '../country'
import OrderSuccess from './OrderSuccess.vue'
import { getCustomerWalletList, getUnCheckMoney } from '@/apis/fund'
import { request } from '@/config/request/interceptors'
import { ShopType } from '@/common/const'
import { COUNTRY } from '@/global'
import { CreateOrderReqDTO } from '@/service/order'


export default /*#__PURE__*/_defineComponent({
  props: [
  'modelValue',
  'modeConfig',
  'cartIdList',
  'layout',
  'pdtFee',
  'adtFee',
  'curPdtFee',
  'list',
  'addressValid',
  'remainList',
  'modeValue',
  'isUseOnTheWayStock',
  'checkList',
  'isTikTokShop2C'
],
  emits: ['success', 'update', 'close'],
  setup(__props, { emit }) {

const props = __props
const unBalanceConfirmRef = ref()
const router = useRouter()
const store = useStore()
const scrollBarRef = ref()



const visible = toRef(props, 'modelValue')
const shopname = computed(() => store.getters.shopname)
const orderCode = ref('')
const openMemberRef = ref()
const token = store.getters.token
/** 下单成功提示弹窗 */
const confirmationVisible = ref(false)
/** 下单成功提示信息 */
const confirmationInfo = ref<OrderSuccessInfoDTO[]>([])
// 
const orderSuccess = ref()
const cnWareName = computed(() => {
  return (store.getters.shopReplenishInfo?.warehouseList ?? [])?.find(v => v.warehouseCountry === 'CN')?.warehouseNameTranslate ?? t('中国')
})

const list: any = ref([])
let isWachList = false
// 监听list变化 购物车附加项修改后也要同步
watch(() => [props.cartIdList, props.list], () => {
  list.value = props.list.map((v: any) => {
    const { cartGroupNo } = v
    const cartList = v.cartList.filter((v: any) =>
      props.cartIdList.includes(v.cartId)
    )
    return { cartList: splitGp(cartList), cartGroupNo }
  })
  if (visible.value && isWachList) {
    calcCombineStockPrice()
    isWachList = false
  }
}, {
  deep: true
})
/**
   * 组合商品直发时，将组合的子商品拆开
   * @param cartList
   */
const splitGp = (cartList: any[]) => {
  if (props.modeConfig.value && cartList[0] && cartList[0].productType === 3) {
    const gp = { ...cartList[0] }
    const sub = gp.orderQuantity > gp.stockQuantity ? gp.combinationProductItemList : []
    if (!props.isTikTokShop2C && sourceCountryRef.value !== COUNTRY.JP) {
      gp.orderQuantity = gp.stockQuantity
    }
    gp.buyQuantity = 0
    gp.price = 0
    gp.totalPrice = 0
    return gp.stockQuantity ? [gp, ...sub] : sub
  } else {
    return cartList
  }
}
const [loading, commit] = useRequest(() => {
  return getUser(token).then(async (res) => {
    if (res.success) {
      // 不限制
      if (res.data.membership.templateLevel === -99999) {
        openMemberRef.value.open()
      } else {
        let isWarn = false
        let minWarn = false
        // 倍数报错
        let handWarn = false
        if (props.modeConfig.value === 0) {
          // 囤货组合商品 提交订单前校验商品是否失效
          const ids: any[] = []
          console.log('list.value', list.value)
          list.value.forEach((item: any) => {
            item.cartList.forEach((i: any) => {
              if (i.productType === 3) {
                handWarn = i.combinationProductItemList.some((i: any) => i.handLack) || handWarn
                ids.indexOf(i.cartId) === -1 && (ids.push(i.cartId))
                // 校验是否满足起订量
                if (calcMinQuantity(i.combinationProductItemList)) {
                  minWarn = true
                }
              } else {
                handWarn = i.handLack || handWarn
                if (spuBuyNum.value[i.productCode] < i.minOrderQuantity && !i.isOnePsale) {
                  minWarn = true
                }
              }
            })
          })
          if (minWarn) {
            ElMessage.error(t('存在不足起订量的商品，请修改数量'))
            return
          }
          if (handWarn) {
            ElMessage.error(t('商品数量选择不正确'))
            return
          }
          if (ids.length > 0) {
            await searchInvaidSku(ids)
            list.value.forEach((item: any) => {
              item.cartList.forEach((i: any) => {
                if (i.productType === 3) {
                  // 如果是失效商品并且购买数大于0则提示
                  i.combinationProductItemList.forEach((v: any) => {
                    if (invalidSkuList.value.indexOf(v.productSku) > -1 && (Math.round(v.orderQuantity - v.remainCombinationQuantity - v.stockNum) > 0)) {
                      isWarn = true
                    }
                  })
                }
              })
            })
          }
        }
        if (isWarn) {
          confirmDialog({
            title: 'ご注意ください',
            text: t('商品已失效，库存不满足需求量，无法下单')
          })
          return
        }
        // 确定商品是否正常
        const isWarnGoods = await isHaveErrorGoods()
        if (isWarnGoods) {
          return
        }
        // 确定钱包余额
        const wallet = await getWallet({
          customerShopId: store.getters.curShop,
          currencyCode: sourceCountryInfo.value?.currency
        }).then((res) => res.data.availableAmount)
        if (wallet < billProductFee.value + additionFee.value) {
          getCustomerWalletList({
            stationCode: useSite2Station(),
            currencyCode: sourceCountryInfo.value?.currency
          }).then(async (res: any) => {
            const { data } = res
            const recharge = data.find?.((e: any) => e.accountType === 1)?.availableAmount ?? 0
            const unCheckCnyAmt = await getUnCheckMoney({ currencyCode: sourceCountryInfo.value?.currency ?? 'CNY' }).then(res => {
              return res.data.unCheckCnyAmt
            })
            if (recharge > 0 || unCheckCnyAmt > 0) {
              bus.emit('openUnRechargeModal', {
                currency: sourceCountryInfo.value?.currency ?? 'CNY',
                unCheckCnyAmt
              })
            } else {
              // showModal('error', {})
              unBalanceConfirmRef.value?.open()
            }
          })
          return
        }
        //
        const { cartIdList, modeConfig, addressValid, remainList, modeValue } = props
        let [deliverAddress, clear]: any[] = [{}, () => { }]
        if (modeConfig.value) {
          [deliverAddress, clear] = await addressValid()
        }
        const { purchasePriceAdd } = await purchaseCfg().then((res) => res.data)
        const priceFloatPercent = purchasePriceAdd ?? 0
        const data: any = {
          estimatedTotalOrderPrice: Math.round((productFee.value + additionFee.value) * 100) / 100,
          cartIdList,
          orderType: modeConfig.value ? 1 : 2,
          priceFloatPercent,
          customerOrderNo: orderCode.value,
          wareHouseLocation: modeConfig.value === 1 && sourceCountryRef.value === COUNTRY.JP ? COUNTRY.JP : COUNTRY.CN

        }
        if (modeConfig.value) {
          const { deliveryAdditionalList, ...rest } = deliverAddress
          data.deliverAddress = rest
          data.deliveryAdditionalList = deliveryAdditionalList
          //   是否选择在途库存
          data.useOneTheWayInventory = props.isUseOnTheWayStock
        } else {
          data.remainCombinationProductItemList = remainList
          // 组合落单匹配
          let combineSkuList: any = []
          list.value.forEach((item: any) => {
            item.cartList.forEach((i: any) => {
              if (i.productType === 3) {
                combineSkuList = [
                  ...combineSkuList,
                  ...i.combinationProductItemList
                ]
              }
            })
          })
          data.combinationProductItemStockList = combineSkuList.map((item: any) => {
            return {
              combinationProductSku: item.combinationProductSku,
              cartId: item.cartId,
              remainCombinationQuantity: item.remainCombinationQuantity,
              stockNum: item.stockNum,
              shopProductSku: item.shopProductSku
            }
          })
          // 囤货需要传囤货到日本还是中国
          data.overSeasStockFlag = stockWarehouse.value === 'JP' ? 1 : 0
        }

        return request.order.cart.createOrder(data).then((res) => {
          if (res.success) {
            // if (res.data.some((v: any) => v.code === '240000048')) {
            //   bus.emit('orderExhausted')
            //   return
            // }
            // --------订单埋点逻辑 -----start
            res.data?.forEach(async (i: any) => {
              if (!i.success) return
              const res1 = await getPlatformOrderDetail({
                platformOrderId: i.platformOrderId
              })
              const OrderProductDetailList: any = []
              if (res1.success) {
                res1.data?.platformOrderItemList?.forEach((j: any) => {
                  OrderProductDetailList.push({
                    product_num: j.orderQuantity,
                    product_title_ja: j.productTitleJp,
                    product_code: j.productCode
                  })
                })
              }
              taTrack({
                event: TaEvent.ORDER_PAY,
                value: {
                  currency: 'CNY',
                  order_no: i.platformOrderNo,
                  pay_amount: i.estimatedTotalOrderPrice,
                  pay_result: i.success ? 'success' : 'fail',
                  fail_reason: !i.success ? i.message : '',
                  order_product_detail: OrderProductDetailList
                }
              })
            })

            // debugger
            // --------订单埋点逻辑 -----end

            orderCode.value = ''
            // 下单地址清空
            clear()
            store.commit('bussiness/deliverData', null)
            emit('success', (type: boolean) => {
              if (isJA()) {
                if (res.data?.every(v => v.success)) {
                  localStorage.setItem('ckb_last_order_id', res.data?.[0]?.platformOrderId)
                  const firstOrder = res.data?.find(v => v.firstOrderFlag)
                  if (firstOrder) {
                    const hasCoupon = firstOrder.meetFreeShipFlag
                    window.location.href = `/order_complete_first?hasCoupon=${hasCoupon ? 1 : 0}`
                    return
                  } else {
                    window.location.href = '/order_complete'
                    return
                  }
                }
              }
              if (res.data.some((v: any) => !v.success)) {
                confirmationInfo.value = res.data
                confirmationVisible.value = true
                return
              }
              // 下单成功 还是 提示关联辅料
              if (type) {
                showModal('info', {})
              } else {
                if (!isD2C() && res.data.every((v: any) => v.success)) {
                  return orderSuccess.value.open(res.data)
                } else {
                  confirmationInfo.value = res.data
                  confirmationVisible.value = true
                }
              }
            })
          } else {
            // todo
            if (!modeConfig.value) {
              isWachList = true
            }
            // 错误码为oem库存不足不需要刷新
            if (res.code !== '22010092') {
              emit('update')
            }

            if (res.code === '22010029' || res.code === '22110002') {
              emit('close', true)
              confirmDialog({
                title: t('注意2'),
                text: t('库存发生变更，请重新提交订单')
              })
            }
          }
        })
      }
    }
  })
})

const errorGoods: any = ref({})
// 是否有异常商品
const isHaveErrorGoods = () => {
  const ids: any[] = []
  list.value.forEach((item: any) => {
    item.cartList.forEach((i: any) => {
      // 囤货的校验剔除
      if (props.modeConfig.value === 1 || (props.modeConfig.value === 0 && i.productType !== 3)) {
        ids.indexOf(i.cartId) === -1 && (ids.push(i.cartId))
      }
    })
  })
  if (ids.length === 0) return false
  return request.order.cart.createOrderPreCheck({
    orderType: props.modeConfig.value === 1 ? 1 : 2,
    wareHouseLocation: sourceCountryRef.value === COUNTRY.JP ? COUNTRY.JP : COUNTRY.CN,
    cartIds: ids
  }).then((res) => {
    errorGoods.value = {}
    const { invalidProductSkuList, banProductSkuList, stockNotEnoughList, oemTypeRepeatSkuList } = res.data!
    let errorText = ''
    if (invalidProductSkuList?.length) {
      const map = arr2map(invalidProductSkuList)
      list.value.forEach((v: any) => {
        if (map.get(v.productSku)) {
          if (v.onTheWayStockQuantity < v.orderQuantity) {
            errorText = t('存在已失效商品，请调整商品')
            errorGoods.value[v.productSku] = 1
          }
        }
      })
    }
    if (banProductSkuList?.length) {
      errorText = errorText ? t('多个商品有异常，请重新调整商品') : t('存在已下架商品，请调整商品')
      banProductSkuList.forEach((item: string) => {
        errorGoods.value[item] = 2
      })
    }
    if (stockNotEnoughList?.length) {
      errorText = errorText ? t('多个商品有异常，请重新调整商品') : t('存在库存过低商品，请调整发货量或及时补充库存')
      stockNotEnoughList?.forEach((item: string) => {
        errorGoods.value[item] = 3
      })
      const noStockGoods: any = []
      list.value.forEach((item: any) => {
        item.cartList.forEach((cItem: any) => {
          if (cItem.channel === 5 && stockNotEnoughList.includes(cItem.productSku)) {
            noStockGoods.push(cItem)
          }
        })
      })
      if (noStockGoods.length > 0) {
        emit('close', true, noStockGoods)
        return true
      }
    }
    if (oemTypeRepeatSkuList?.length) {
      errorText = errorText ? t('多个商品有异常，请重新调整商品') : t('同一个订单只能存在一个OEM商品下单')
    }
    if (!errorText) {
      return false
    } else {
      ElMessage({
        dangerouslyUseHTMLString: true,
        message: errorText,
        type: 'error'
      })
      getNewCartList()
      return true
    }
  })
}
const showTiktok = computed(() => Number(store.getters.shopInfo?.customerShopPlatform) === ShopType.TIKTOK && isD2C() && sourceCountryRef.value !== COUNTRY.KR)

// 获取购物车最新数据刷新库存字段
const getNewCartList = () => {
  request.order.cart.list({
    orderType: props.modeConfig.value === 1 ? 1 : 2,
    wareHouseLocation: showTiktok.value ? (sourceCountryRef.value === COUNTRY.JP ? COUNTRY.JP : COUNTRY.CN) : COUNTRY.CN
  }).then((res: any) => {
    list.value.forEach((item: any) => {
      item.cartList && item.cartList.forEach((temp: any) => {
        res.data.forEach((cartItem: any) => {
          cartItem.cartList.forEach((cartTemp: any) => {
            if (temp.cartId === cartTemp.cartId) {
              // temp.stockQuantity = cartTemp.stockQuantity
              temp.orderQuantity = cartTemp.orderQuantity
              temp.buyQuantity = null
            }
          })
        })
      })
    })
  })
}
const showModal = (type: 'success' | 'error' | 'info', data: any) => {
  const msg1 = data.estimatedTotalOrderPrice === data.totalFreezeAmount ? t('订单已生成，请随时关注订单动态') : t('最新价格为X元').replace('X', data.totalFreezeAmount)
  const success = {
    msg: [
      msg1,
      t('5s后跳转订单详情'),
      t('查看订单详情'),
      t('下单成功')
    ],
    ok: (data: any) => {
      return useRtfix('OrderInfo', {
        params: { id: data.platformOrderId }
      })
    }
  }
  const error = {
    msg: [
      t('您的余额不足，请充值后再次支付'),
      t('5s后跳转充值页面'),
      t('去充值2'),
      t('下单失败3')
    ],
    ok: (data: any) =>
      useRtfix('CustomerFund', {
        query: {
          currencyCode: sourceCountryInfo.value?.currency
        }
      })
  }
  const info = {
    msg: [
      t('系统查询到您有辅料未添加到附加项配置'),
      t('5s后跳转附加项配置'),
      t('去配置'),
      t('下单成功')
    ],
    ok: (data: any) =>
      useRtfix('setupShop', {
        query: { type: 'ShopAddition', sourceCountry: sourceCountryRef.value }
      })
  }
  const { msg, ok } = { success, error, info }[type]

  ElMessageBox.confirm(
    `
            <div class="text-ct">${msg[0]}</div>
            <div class="text-ct">${msg[1]}</div>
            `,
    msg[3],
    {
      dangerouslyUseHTMLString: true,
      confirmButtonText: msg[2],
      cancelButtonText: t('回到首页'),
      distinguishCancelAndClose: true,
      customClass: 'stupid-el',
      type
    }
  )
    .then(() => {
      router.push(ok(data))
    })
    .catch((action) => {
      if (action === 'cancel') {
        location.href = '/'
      }
    })
  // 5s后跳转订单详情
  setTimeout(() => {
    const a: any = document.querySelector('.stupid-el')
    if (a) {
      const m = a.parentNode.parentNode
      m.parentNode.removeChild(m)
      router.push(ok(data))
    }
  }, 5000)
}

watch(() => props.cartIdList, () => {
  // 监听列表变化，重置异常商品
  errorGoods.value = {}
}, {
  deep: true
})

const closeDialog = () => {
  // 是否有异常商品
  const isWarn = Object.keys(errorGoods.value).length > 0
  // 是否有组合商品
  let isCombine = false
  list.value.forEach((item: any) => {
    item.cartList.forEach((temp: any) => {
      if (props.cartIdList.includes(temp.cartId) && temp.productType === 3) {
        isCombine = true
      }
    })
  })
  // console.log('asd', list.value, props.cartIdList, props.modeConfig.value)
  // 组合囤货关闭弹窗需要重新刷新数据
  emit('close', isWarn || (isCombine && props.modeConfig.value === 0) || false)
}

const skuStock: any = {}
const invalidSkuList: any = ref([])
watch(visible, (newValue) => {
  if (newValue) {
    calcCombineStockPrice()
  }
})

const calcCombineStockPrice = () => {
  combineAdditionTotalFee.value = 0
  if (props.modeConfig.value) return
  // 获取组合sku
  const combineSkuList: number[] = []
  list.value.forEach((item: any) => {
    item.cartList.forEach((i: any) => {
      if (i.productType === 3) {
        combineSkuList.indexOf(i.cartId) === -1 && (combineSkuList.push(i.cartId))
      }
    })
  })
  if (combineSkuList.length === 0) return
  request.order.cart.queryCombinationSubItemStock({
    cartList: combineSkuList,
    wareHouseLocation: props.modeConfig.value === 0 ? COUNTRY.CN : (sourceCountryRef.value === COUNTRY.JP ? COUNTRY.JP : COUNTRY.CN),
    overSeasStockFlag: stockWarehouse.value === 'JP' ? 1 : 0
  }).then((res: any) => {
    if (!res.success) return
    res.data.forEach((i: any) => {
      skuStock[i.shopProductSku] = {
        ...i,
        stockNum: i.stockNum < 0 ? 0 : i.stockNum
      }
    })
    const copyStock = cloneDeep(skuStock)
    // 根据库存从上到下匹配库存质检区>成品区
    list.value.forEach((item: any) => {
      item.cartList.forEach((i: any) => {
        if (i.productType === 3) {
          i.combinationProductItemList.forEach((v: any) => {
            if (!copyStock[v.shopProductSku]) {
              copyStock[v.shopProductSku] = {
                remainCombinationQuantity: 0,
                stockNum: 0
              }
            }
            v.remainCombinationQuantity = Math.min(v.orderQuantity, copyStock[v.shopProductSku]?.remainCombinationQuantity ?? 0)
            copyStock[v.shopProductSku].remainCombinationQuantity -= v.remainCombinationQuantity
            v.stockNum = Math.min(v.orderQuantity - v.remainCombinationQuantity, copyStock[v.shopProductSku]?.stockNum ?? 0)
            copyStock[v.shopProductSku].stockNum -= v.stockNum
            v.totalRemainCombinationQuantity = skuStock[v.shopProductSku]?.remainCombinationQuantity ?? 0
            v.totalStockNum = skuStock[v.shopProductSku]?.stockNum ?? 0
          })
        }
      })
    })
    computeFee()
  })
  searchInvaidSku(combineSkuList)
}
const searchInvaidSku: any = async (combineSkuList: any) => {
  // 查询组合商品的失效商品
  request.order.cart.createOrderPreCheck({
    orderType: props.modeConfig.value === 1 ? 1 : 2,
    cartIds: combineSkuList,
    wareHouseLocation: sourceCountryRef.value === COUNTRY.JP ? COUNTRY.JP : COUNTRY.CN
  }).then((res: any) => {
    if (res.success) {
      invalidSkuList.value = [
        ...res.data.banProductSkuList,
        ...res.data.invalidProductSkuList
      ]
      return invalidSkuList.value
    }
  })
}
const changeStock = (key: string, value: string, item: any, data: any) => {
  if (!skuStock[item.shopProductSku] || !skuStock[item.shopProductSku][key]) {
    // 没有库存不允许填写
    item[key] = 0
    return
  }
  const numValue = Number(value)
  // 总库存数
  const totalNum = skuStock[item.shopProductSku][key]
  // 总购买数-剩余购买数
  const totalBuyNum = item.orderQuantity - item[key === 'remainCombinationQuantity' ? 'stockNum' : 'remainCombinationQuantity']
  // 其他组合已使用库存数
  let keyNum = 0
  list.value.forEach((listItem: any) => {
    listItem.cartList.forEach((i: any) => {
      if (i.productType === 3) {
        i.combinationProductItemList.forEach((v: any) => {
          if (v.shopProductSku === item.shopProductSku) {
            keyNum += Number(v[key])
            if (v.cartId === item.cartId) {
              keyNum -= v[key]
            }
          }
        })
      }
    })
  })
  // 仓库剩余库存数量
  const otherNum = totalNum - keyNum
  item[key] = Math.min(otherNum, totalBuyNum, numValue)
  computeFee()
}
const productFee = ref(props.pdtFee)
const additionFee = ref(props.adtFee)
/**
   * billProductFee 账期商品总价
   * 如果为账期商品，支付时，使用该字段；如果是普通商品，该字段和productFee支付总价一样，支付时，也使用该字段；
   */
const billProductFee = ref(props.curPdtFee)
watch(() => [props.pdtFee, props.adtFee, props.curPdtFee], (newValue: any) => {
  productFee.value = newValue[0]
  additionFee.value = newValue[1]
  billProductFee.value = newValue[2]
})
// 实际购买商品数量 用来计算起订量
const spuBuyNum: any = ref({})
// 计算费用
const computeFee = () => {
  spuBuyNum.value = {}
  combineAdditionTotalFee.value = 0
  let skuList: any[] = []
  let pFee = 0
  let adtFee = 0
  let billPFee = 0
  list.value.forEach((i: any) => {
    i.cartList.forEach((v: any) => {
      if (v.productType === 3) {
        skuList = [
          ...skuList,
          v,
          ...v.combinationProductItemList
        ]
        combineAdditionTotalFee.value += v.combinationProductItemList.reduce((total: number, v: any): number => {
          return total + v.stockNum
        }, 0) * combineAdditionUnitFee.value
        v.combinationProductItemList.forEach((item: any) => {
          if (item.productCode) {
            spuBuyNum.value[item.productCode] = (spuBuyNum.value[item.productCode] ?? 0) + item.orderQuantity - item.remainCombinationQuantity - item.stockNum
          }
        })
      } else {
        if (v.productCode) {
          spuBuyNum.value[v.productCode] = (spuBuyNum.value[v.productCode] ?? 0) + v.buyQuantity
        }
        skuList.push(v)
      }
    })
  })
  // 计算费用
  const copySku = cloneDeep(skuList)
  calcFee(copySku, sourceCountryRef.value).then(async () => {
    console.log('copySku', copySku)
    copySku.forEach((i: any) => {
      pFee += getTrueNumber(i.totalPrice)
      adtFee += getTrueNumber(i.adtPrice)
      billPFee += getTrueNumber(i.curPdtPirce)
    })
    list.value.forEach((i: any) => {
      i.cartList.forEach(async (v: any) => {
        if (v.productType === 3) {
          const fee = await calcGpAdt(v, 0, sourceCountryRef.value)
          adtFee += fee
          additionFee.value = adtFee
          // 组合商品小计重新计算
          let totalPrice = 0
          let curPdtPirce = 0
          let price = 0
          v.combinationProductItemList.forEach((item: any) => {
            const paymentDetail = item.paymentDetail && JSON.parse(item.paymentDetail || [])
            // 比例
            const period = (paymentDetail && paymentDetail[0]?.paymentPeriod) || 1
            const skuObj = copySku.filter((i) => i.combinationProductItemId).find((skuItem: any) => skuItem.productSku === item.productSku && item.productCode === skuItem.productCode) || {}
            console.log('子商品', skuObj)
            totalPrice += (skuObj.price ?? 0) * (item.orderQuantity - (item?.remainCombinationQuantity ?? 0) - (item?.stockNum ?? 0))
            curPdtPirce += (skuObj.price ?? 0) * (item.orderQuantity - (item?.remainCombinationQuantity ?? 0) - (item?.stockNum ?? 0)) * period
            price += (skuObj.price ?? 0) * item.unitNums
            item.handLack = skuObj.handLack
          })
          v.price = price
          v.totalPrice = totalPrice
          v.curPdtPirce = curPdtPirce
        } else if (!v.livePriceFlag || v.livePriceFlag === 0) {
          // 重新计算阶梯价
          console.log('copySku', copySku, v)
          const skuObj = copySku.filter((i) => !i.combinationProductItemId).find((skuItem: any) => skuItem.productSku === v.productSku && v.productCode === skuItem.productCode) || {}
          v.price = skuObj.price
          v.totalPrice = skuObj.totalPrice
          v.curPdtPirce = skuObj.curPdtPirce
          v.handLack = skuObj.handLack
        }
      })
    })
    console.log('aa', list.value)
    productFee.value = pFee
    additionFee.value = adtFee
    billProductFee.value = billPFee
  })
}
// 组合费用（使用成品区）
const combineAdditionUnitFee = ref(0)
const combineAdditionTotalFee = ref(0)
getCombinationServiceFreezeChargeApi({}).then((res: any) => {
  if (res.success) {
    combineAdditionUnitFee.value = res.data ?? 0
  }
})
const calcMinQuantity = (arr: any[]) => {
  let error = false
  arr.forEach((item: any) => {
    if (spuBuyNum.value[item.productCode] < item.minOrderQuantity && (item.orderQuantity - item.remainCombinationQuantity - item.stockNum > 0) && !item.isOnePsale) {
      error = true
    }
  })
  return error
}
const scrollHeight = ref(380)
onMounted(() => {
  const height = document.body.offsetHeight - 500
  scrollHeight.value = height > 380 ? 380 : height
})

return (_ctx: any,_cache: any) => {
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_drawer, _mergeProps({ "model-value": _unref(visible) }, _ctx.$attrs, {
      width: "1200px",
      "before-close": closeDialog,
      "custom-class": 'shopcart-comfirm-order shopcart-comfirm-order-' + _unref(useSite)(),
      direction: "btt",
      title: _unref(t)('确认订单信息')
    }), {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.layout, (v) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: v.label,
                  class: _normalizeClass({ 'fx-1': v.width === 'auto' }),
                  style: _normalizeStyle({ width: v.width + 'px' })
                }, _toDisplayString(v.label), 7))
              }), 128))
            ]),
            _createVNode(_component_el_scrollbar, {
              height: `${scrollHeight.value}px`,
              always: "",
              ref: (_value, _refs) => {
                _refs['scrollBarRef'] = _value
                scrollBarRef.value = _value
              }
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (v) => {
                  return (_openBlock(), _createBlock(PrevItem, {
                    key: v.cartGroupNo,
                    layout: __props.layout,
                    data: v,
                    errorGoods: errorGoods.value,
                    mode: __props.modeConfig.value,
                    onChange: changeStock,
                    invalidSkuList: invalidSkuList.value,
                    spuBuyNum: spuBuyNum.value
                  }, null, 8, ["layout", "data", "errorGoods", "mode", "invalidSkuList", "spuBuyNum"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["height"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(t)('购买店铺')) + "：", 1),
                _createElementVNode("span", null, _toDisplayString(_unref(shopname)), 1)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(t)('购买类型')) + "：", 1),
                _createElementVNode("span", null, _toDisplayString(__props.modeConfig.label), 1)
              ]),
              (__props.modeConfig.value === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(t)('囤货仓库')) + "：", 1),
                    _createElementVNode("span", null, _toDisplayString(_unref(stockWarehouse) === 'JP' ? _unref(t)('日本仓库') : _unref(cnWareName)), 1)
                  ]))
                : _createCommentVNode("", true),
              (__props.modeConfig.value || !_unref(isD2C)())
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("span", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createTextVNode(_toDisplayString(_unref(t)(_unref(isD2C)() ? '自定义订单编号' : '订单标题')) + " ： ", 1),
                        _createVNode(_component_el_tooltip, {
                          effect: "light",
                          placement: "top",
                          "popper-class": "tool-tip-no-border"
                        }, {
                          content: _withCtx(() => [
                            _createElementVNode("div", {
                              style: _normalizeStyle({ maxWidth: _unref(isJA)() ? '340px' : _unref(isEN)() ? '380px' : '340px' })
                            }, [
                              _createTextVNode(_toDisplayString(_unref(t)('用于识别不同订单。')), 1),
                              _hoisted_15,
                              _createTextVNode(" " + _toDisplayString(_unref(t)('您可以直接引用自家店铺的客户订单号，')), 1),
                              _hoisted_16,
                              _createTextVNode(" " + _toDisplayString(_unref(t)('也可以另外输入文字区分您的订单。')), 1),
                              _hoisted_17,
                              _hoisted_18,
                              _createElementVNode("div", _hoisted_19, [
                                _createElementVNode("div", null, _toDisplayString(_unref(t)('例）')), 1),
                                _createElementVNode("div", null, [
                                  _createTextVNode(_toDisplayString(_unref(t)('＜店铺订单号＞ 503-0575395-6075865')), 1),
                                  _hoisted_20,
                                  _createTextVNode(" " + _toDisplayString(_unref(t)('＜订单标题＞ 2024年1月24日李先生的订单已读')), 1)
                                ])
                              ])
                            ], 4)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(QuestionMark, {
                              size: 14,
                              color: "#333"
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createVNode(_component_el_input, {
                      modelValue: orderCode.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((orderCode).value = $event)),
                      maxlength: "30"
                    }, null, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(FigurePay, {
              confirm: true,
              pdtFee: productFee.value,
              adtFee: additionFee.value,
              onCommit: _cache[1] || (_cache[1] = (e) => _unref(commit)()),
              errorGoods: errorGoods.value,
              combineAdditionTotalFee: combineAdditionTotalFee.value,
              curPdtFee: billProductFee.value,
              mode: __props.modeValue
            }, null, 8, ["pdtFee", "adtFee", "errorGoods", "combineAdditionTotalFee", "curPdtFee", "mode"])
          ])
        ], 512), [
          [_directive_loading, _unref(loading)]
        ])
      ]),
      _: 1
    }, 16, ["model-value", "custom-class", "title"]),
    _createVNode(OpenMember, {
      ref: (_value, _refs) => {
        _refs['openMemberRef'] = _value
        openMemberRef.value = _value
      }
    }, null, 512),
    _createVNode(Confirmation, {
      visible: confirmationVisible.value,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((confirmationVisible).value = $event)),
      confirmationInfo: confirmationInfo.value,
      onClose: _cache[3] || (_cache[3] = ($event: any) => (emit('close', 1)))
    }, null, 8, ["visible", "confirmationInfo"]),
    _createVNode(OrderSuccess, {
      ref: (_value, _refs) => {
        _refs['orderSuccess'] = _value
        orderSuccess.value = _value
      }
    }, null, 512),
    _createVNode(UnBalanceConfirm, {
      ref: (_value, _refs) => {
        _refs['unBalanceConfirmRef'] = _value
        unBalanceConfirmRef.value = _value
      }
    }, null, 512)
  ], 64))
}
}

})